import { render, staticRenderFns } from "./DeleteTaskDialog.vue?vue&type=template&id=2edb0e6a&scoped=true&"
import script from "./DeleteTaskDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTaskDialog.vue?vue&type=style&index=0&id=2edb0e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb0e6a",
  null
  
)

export default component.exports